import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { ReceitaEducacaoDto } from '../../dtos/receita-educacao-dto';


@Injectable({
  providedIn: 'root',
})
export class ReceitaEducacaoService {
  private apiUrl = `${environment.apiUrl}/receita-educacao`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarPorMunicipio(codigoMunicipio: number, ano: number): Observable<ReceitaEducacaoDto> {
    return this.caqRequestService
      .get<ReceitaEducacaoDto>(`${this.apiUrl}/municipio/${codigoMunicipio}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorPlanoEstadual(codigoEstado: number, ano: number): Observable<ReceitaEducacaoDto> {
    return this.caqRequestService
      .get<ReceitaEducacaoDto>(`${this.apiUrl}/estado/plano/${codigoEstado}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorRedeEstadual(codigoEstado: number, ano: number): Observable<ReceitaEducacaoDto> {
    return this.caqRequestService
      .get<ReceitaEducacaoDto>(`${this.apiUrl}/estado/rede/${codigoEstado}/${ano}`)
      .pipe(map((response) => response));
  }

  buscarPorAno(ano: number): Observable<ReceitaEducacaoDto> {
    return this.caqRequestService
      .get<ReceitaEducacaoDto>(`${this.apiUrl}/${ano}`)
      .pipe(map((response) => response));
  }
}
